class ThemeService {
  private scanlinesEnabled: boolean = true;

  constructor() {
    this.init();
  }

  private init() {
    const saved = localStorage.getItem('mastui_scanlines');
    if (saved !== null) {
      this.scanlinesEnabled = saved === 'true';
    } else {
      this.scanlinesEnabled = true;
    }
    this.apply();
  }

  public toggleScanlines(): boolean {
    this.scanlinesEnabled = !this.scanlinesEnabled;
    localStorage.setItem('mastui_scanlines', String(this.scanlinesEnabled));
    this.apply();
    return this.scanlinesEnabled;
  }

  public isScanlinesEnabled(): boolean {
    return this.scanlinesEnabled;
  }

  private apply() {
    const body = document.body;
    if (this.scanlinesEnabled) {
      body.classList.add('crt');
    } else {
      body.classList.remove('crt');
    }
  }
}

export const themeService = new ThemeService();
